<template>
    <flex-container
        :gap="Size.sm"
        direction="column"
    >
        <text-heading>
            Embed Code
        </text-heading>
        <text-description>
            Hieronder vind je de embed code die je kunt toevoegen aan je website of Google Tag Manager.
            <template v-if="hasWinckBranding()">
                Je hebt vier opties om dit te doen:
            </template>
            <template v-else>
                Je hebt drie opties om dit te doen:
            </template>
        </text-description>
        <text-description>
            <ol>
                <li>
                    <text-description>
                        Zelf toevoegen aan Google Tag Manager
                        <br />
                        Voeg de code handmatig toe als een nieuwe tag in jouw Google Tag Manager-container.
                    </text-description>
                </li>
                <li>
                    <text-description>
                        Wij voegen de code toe voor je
                        <br />
                        Weet je niet precies hoe dit werkt? Nodig ons uit in jouw Google Tag Manager, dan regelen wij
                        het voor je.
                    </text-description>
                </li>
                <li>
                    <text-description>
                        Toevoegen via je eigen website CMS
                        <br />
                        Als je een CMS gebruikt zoals WordPress, Shopify of een ander platform, voeg dan de code toe via
                        de sectie voor aangepaste scripts of integraties.
                    </text-description>
                </li>
                <li v-if="hasWinckBranding()">
                    <text-description>
                        WordPress? Binnen één minuut live.
                        <br />
                        Installeer onze
                        <a
                            href="https://wordpress.org/plugins/ai-chatbot-for-winck/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            WordPress-plugin
                        </a>
                        en vul jouw Brand ID in. Binnen één minuut staat jouw AI Agent live op je website.
                        <br />
                        Dit is jouw Brand ID:
                        <text-decorator bold>
                            {{ assistent.brand.id }}
                        </text-decorator>
                    </text-description>
                </li>
            </ol>
        </text-description>
        <text-description>
            <brand-copy-embed-textarea
                :brand-id="assistent.brand.id.value"
            />
        </text-description>
    </flex-container>
</template>

<script setup lang="ts">
    import type { Assistent } from '@keyvue/one-api-client';
    import { type Ref, ref } from 'vue';
    import { Size, TextDecorator, TextDescription, TextHeading } from '@keyvue/one-ui';
    import hasWinckBranding from '@/services/app-branding/helpers/hasWinckBranding';
    import BrandCopyEmbedTextarea from '@/company/brand/components/BrandCopyEmbedTextarea.vue';

    const props = defineProps<{ modelValue: Assistent }>();
    const assistent = ref(props.modelValue) as Ref<Assistent>;
</script>
